import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { PermissionsService } from '@frontendlib/common/features/permissions/services/permissions.service';
import { asSubject, type Actions, type Subjects } from '@sharedlib/common/permissions/types/Permissions';
import { type WorkspaceIdentity } from '@modules/common/services/workspace-identity.service';
import { itemWorkspace, type WorkspaceItem } from './item-workspace-scope';

@Component({
  selector: 'app-item-workspace-access',
  templateUrl: './item-workspace-access.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemWorkspaceAccessComponent {
  public readonly revision = input(0);
  public readonly identity = input<WorkspaceIdentity>();
  public readonly item = input<WorkspaceItem>();
  protected readonly workspace = computed(() => {
    this.revision();
    return itemWorkspace(this.identity(), this.item());
  });
  private readonly permissions = inject<PermissionsService<Actions, Subjects | 'Space'>>(PermissionsService);
  protected readonly teamManager = computed(() =>
    this.workspace() === 'team' &&
    this.permissions.checkPermission('update', asSubject('Space', { uid: this.identity()?.spaceTenantId })),
  );
  protected readonly permission = computed(() =>
    this.workspace() === 'team' && !this.teamManager() ? 'Edit content' : 'Manage',
  );
}
